import _ from "lodash";
import { CriteriaDirectoryTariffCoaCheckboxOption } from "presentation/constant/DocumentEnquiry/CriteriaDirectoryCheckboxOption";
import { DocumentEnquiryConstant } from "presentation/constant/DocumentEnquiry/DocumentEnquiryConstant";
import { useDocumentEnquiryVM } from "presentation/hook/DocumentEnquiry/useDocumentEnquiryVM";
import { useDocumentEnquiryTracked } from "presentation/store/DocumentEnquiry/DocumentEnquiryProvider";
import { CriteriaItemContainer } from "presentation/view/components/CriteriaItemContainer";
import { FieldType, IFieldValue, NbisCommonField } from "presentation/view/components/NbisCommonField";
import { useMemo } from "react";

import {
    HPHGroupTitle
} from "veronica-ui-component/dist/component/core";

export const DocumentEnquiryCriteriaEditTariffCoaPanel = () => {
    const DOC_ENQ_HDR_CONST = DocumentEnquiryConstant.Header;
    const [docEnquiryState] = useDocumentEnquiryTracked();
    const searchCriteria = docEnquiryState.searchCriteria
    const docEnquiryVM = useDocumentEnquiryVM();
    const enabledCriteria = useMemo(() => CriteriaDirectoryTariffCoaCheckboxOption?.find(item => docEnquiryState.enabledSearchCriteria[item.key]), [docEnquiryState.enabledSearchCriteria])

    const memoTariffCodeOptions = useMemo(() => {
        const groupOfTariffCodeOptions = searchCriteria.tariffTypeList?.map(tariffType => docEnquiryState.dynamicOptions.tariffCodeDropdownOptions[tariffType]);
        const commonTariffCodeOptions = _.orderBy(_.uniqBy(_.flatMap(_.concat(groupOfTariffCodeOptions ?? [])), 'value'), 'dropdownLabel');
        return commonTariffCodeOptions;
    }, [searchCriteria.tariffTypeList, docEnquiryState.dynamicOptions.tariffCodeDropdownOptions])

    const memoTariffType = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "150px" }}>
            <NbisCommonField
                errorMessages={{}}
                isReadOnly={false}
                isShowOptional={false}
                sort={false}
                readOnlyValue={searchCriteria.tariffTypeList?.join(',')}
                fieldValue={searchCriteria.tariffTypeList}
                fieldLabel={DOC_ENQ_HDR_CONST.TAR_TYPE}
                isSaveClicked={false}
                fieldType={FieldType.DROPDOWN}
                fieldKey={'tariffTypeList'}
                maxLength={60}
                isMultipleDropDown={true}
                options={docEnquiryState.dynamicOptions.tariffTypeDropdownOptions}
                requiredFieldList={[]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    docEnquiryVM.onSearchFieldChange(fieldKey, fieldValue && fieldValue, fFullValue)} />
            {/* <NbisInputDropDown
                label={DOC_ENQ_HDR_CONST.TAR_TYPE}
                width='150px'
                inputType="freeText"
                mode={'multiple'}
                sort={false}
                value={searchCriteria.tariffTypeList?.map((item) => ({
                    value: item
                }))}
                onChange={(e: any) => {
                    docEnquiryVM.onMultipleDropdownChange(e, 'tariffTypeList')
                    docEnquiryVM.onDropdownChange(EMPTY_DOCUMENT_ENQUIRY_CRITERIA.tariffCodeList, 'tariffCodeList')
                }}
                options={docEnquiryState.dynamicOptions.tariffTypeDropdownOptions} /> */}
        </div>
        , [DOC_ENQ_HDR_CONST.TAR_TYPE, searchCriteria.tariffTypeList, docEnquiryState.dynamicOptions.tariffTypeDropdownOptions, docEnquiryVM])

    const memoTariffCode = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "150px" }}>
            <NbisCommonField
                errorMessages={{}}
                isReadOnly={false}
                isShowOptional={false}
                sort={false}
                readOnlyValue={searchCriteria.tariffCodeList?.join(',')}
                fieldValue={searchCriteria.tariffCodeList}
                fieldLabel={DOC_ENQ_HDR_CONST.TAR_CODE}
                isSaveClicked={false}
                fieldType={FieldType.DROPDOWN}
                fieldKey={'tariffCodeList'}
                maxLength={60}
                isMultipleDropDown={true}
                options={memoTariffCodeOptions}
                requiredFieldList={[]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    docEnquiryVM.onSearchFieldChange(fieldKey, fieldValue && fieldValue, fFullValue)} />
            {/* <NbisInputDropDown
                label={DOC_ENQ_HDR_CONST.TAR_CODE}
                width='150px'
                inputType="freeText"
                mode={'multiple'}
                sort={false}
                value={searchCriteria.tariffCodeList?.map((item) => ({
                    value: item
                }))}
                onChange={(e: any) => docEnquiryVM.onMultipleDropdownChange(e, 'tariffCodeList')
                }
                options={memoTariffCodeOptions} /> */}
        </div>
        , [DOC_ENQ_HDR_CONST.TAR_CODE, searchCriteria.tariffCodeList, memoTariffCodeOptions, docEnquiryVM])

    const memoCostCentreCode = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "330px" }}>
            <NbisCommonField
                errorMessages={{}}
                isReadOnly={false}
                isShowOptional={false}
                readOnlyValue={searchCriteria.costCentreCode || ''}
                fieldValue={searchCriteria.costCentreCode}
                fieldLabel={DOC_ENQ_HDR_CONST.COST_CENTRE_CODE}
                isSaveClicked={false}
                fieldType={FieldType.TEXT}
                fieldKey={'costCentreCode'}
                maxLength={999}
                isTextFieldCapitalize={false}
                requiredFieldList={[]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    docEnquiryVM.onSearchFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [DOC_ENQ_HDR_CONST.COST_CENTRE_CODE, searchCriteria.costCentreCode, docEnquiryVM])

    const memoRevenueCompanyCode = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "330px" }}>
            <NbisCommonField
                errorMessages={{}}
                isReadOnly={false}
                isShowOptional={false}
                readOnlyValue={searchCriteria.revenueCompanyCode || ''}
                fieldValue={searchCriteria.revenueCompanyCode}
                fieldLabel={DOC_ENQ_HDR_CONST.REVENUE_COMPANY_CODE}
                isSaveClicked={false}
                fieldType={FieldType.TEXT}
                fieldKey={'revenueCompanyCode'}
                maxLength={999}
                isTextFieldCapitalize={false}
                requiredFieldList={[]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    docEnquiryVM.onSearchFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [DOC_ENQ_HDR_CONST.REVENUE_COMPANY_CODE, searchCriteria.revenueCompanyCode, docEnquiryVM])

    const memoProductServiceCode = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "330px" }}>
            <NbisCommonField
                errorMessages={{}}
                isReadOnly={false}
                isShowOptional={false}
                readOnlyValue={searchCriteria.productServiceCode || ''}
                fieldValue={searchCriteria.productServiceCode}
                fieldLabel={DOC_ENQ_HDR_CONST.PRODUCT_SERVICE_CODE}
                isSaveClicked={false}
                fieldType={FieldType.TEXT}
                fieldKey={'productServiceCode'}
                maxLength={999}
                isTextFieldCapitalize={false}
                requiredFieldList={[]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    docEnquiryVM.onSearchFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [DOC_ENQ_HDR_CONST.PRODUCT_SERVICE_CODE, searchCriteria.productServiceCode, docEnquiryVM])

    const memoInterCompanyCode = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "330px" }}>
            <NbisCommonField
                errorMessages={{}}
                isReadOnly={false}
                isShowOptional={false}
                readOnlyValue={searchCriteria.interCompanyCode || ''}
                fieldValue={searchCriteria.interCompanyCode}
                fieldLabel={DOC_ENQ_HDR_CONST.INTER_COMPANY_CODE}
                isSaveClicked={false}
                fieldType={FieldType.TEXT}
                fieldKey={'interCompanyCode'}
                maxLength={999}
                isTextFieldCapitalize={false}
                requiredFieldList={[]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    docEnquiryVM.onSearchFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [DOC_ENQ_HDR_CONST.INTER_COMPANY_CODE, searchCriteria.interCompanyCode, docEnquiryVM])

    const memoSalesChannelCode = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "330px" }}>
            <NbisCommonField
                errorMessages={{}}
                isReadOnly={false}
                isShowOptional={false}
                readOnlyValue={searchCriteria.salesChannelCode || ''}
                fieldValue={searchCriteria.salesChannelCode}
                fieldLabel={DOC_ENQ_HDR_CONST.SALES_CHANNEL_CODE}
                isSaveClicked={false}
                fieldType={FieldType.TEXT}
                fieldKey={'salesChannelCode'}
                maxLength={999}
                isTextFieldCapitalize={false}
                requiredFieldList={[]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    docEnquiryVM.onSearchFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [DOC_ENQ_HDR_CONST.SALES_CHANNEL_CODE, searchCriteria.salesChannelCode, docEnquiryVM])

    const memoRevenueAcCode = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "330px" }}>
            <NbisCommonField
                errorMessages={{}}
                isReadOnly={false}
                isShowOptional={false}
                readOnlyValue={searchCriteria.revenueAcCode || ''}
                fieldValue={searchCriteria.revenueAcCode}
                fieldLabel={DOC_ENQ_HDR_CONST.REVENUE_AC_CODE}
                isSaveClicked={false}
                fieldType={FieldType.TEXT}
                fieldKey={'revenueAcCode'}
                maxLength={999}
                isTextFieldCapitalize={false}
                requiredFieldList={[]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    docEnquiryVM.onSearchFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [DOC_ENQ_HDR_CONST.REVENUE_AC_CODE, searchCriteria.revenueAcCode, docEnquiryVM])


    const memoPanel = useMemo(() => <div className='im-charge-data-search-criteria-group'>
        <HPHGroupTitle titleText={DOC_ENQ_HDR_CONST.TARIFF_COA} />
        <CriteriaItemContainer>
            {docEnquiryState.enabledSearchCriteria.tariffTypeList ? memoTariffType : null}
            {docEnquiryState.enabledSearchCriteria.tariffCodeList ? memoTariffCode : null}
        </CriteriaItemContainer>
        <CriteriaItemContainer>
            {docEnquiryState.enabledSearchCriteria.costCentreCode ? memoCostCentreCode : null}
        </CriteriaItemContainer>
        <CriteriaItemContainer>
            {docEnquiryState.enabledSearchCriteria.revenueCompanyCode ? memoRevenueCompanyCode : null}
        </CriteriaItemContainer>
        <CriteriaItemContainer>
            {docEnquiryState.enabledSearchCriteria.productServiceCode ? memoProductServiceCode : null}
        </CriteriaItemContainer>
        <CriteriaItemContainer>
            {docEnquiryState.enabledSearchCriteria.interCompanyCode ? memoInterCompanyCode : null}
        </CriteriaItemContainer>
        <CriteriaItemContainer>
            {docEnquiryState.enabledSearchCriteria.salesChannelCode ? memoSalesChannelCode : null}
        </CriteriaItemContainer>
        <CriteriaItemContainer>
            {docEnquiryState.enabledSearchCriteria.revenueAcCode ? memoRevenueAcCode : null}
        </CriteriaItemContainer>
    </div>,
        [DOC_ENQ_HDR_CONST.TARIFF_COA, docEnquiryState.enabledSearchCriteria.costCentreCode, docEnquiryState.enabledSearchCriteria.interCompanyCode,
        docEnquiryState.enabledSearchCriteria.productServiceCode, docEnquiryState.enabledSearchCriteria.revenueAcCode, docEnquiryState.enabledSearchCriteria.revenueCompanyCode,
        docEnquiryState.enabledSearchCriteria.salesChannelCode, docEnquiryState.enabledSearchCriteria.tariffCodeList, docEnquiryState.enabledSearchCriteria.tariffTypeList,
            memoCostCentreCode, memoInterCompanyCode, memoProductServiceCode, memoRevenueAcCode, memoRevenueCompanyCode, memoSalesChannelCode, memoTariffCode, memoTariffType]);

    if (!enabledCriteria) return null;

    return memoPanel;
};
